import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import { i18nTranslate } from 'src/utils'
import { observer } from 'mobx-react'
import isEmpty from 'lodash/isEmpty'
import { favoritesContainer } from 'src/models'
import { isMerchPLP, enableQuickView } from 'config/appConfig'
import {
  Pagination,
  ProductCard,
  QuickView,
  MetaDecorator,
} from 'src/views/components'
import { productDeps } from 'src/deps'
import './styles.scss'

@observer
class Favorites extends React.Component {
  initPageForFavorites = async () => {
    favoritesContainer.activePage = 1
    await favoritesContainer.getFavoriteProductsForFavoritesPage(1)
  }
  componentDidMount() {
    this.initPageForFavorites()
  }

  renderProducts = (item = {}, index) => {
    const { product = {}, properties = {} } = item
    let productCard = null
    const productType = product.type || ''
    let isReplacementItem = false
    if (productType === 'bundle' || productType === 'kit') {
      isReplacementItem = productDeps.getIsReplacementItem(product)
    } else {
      isReplacementItem = productDeps.getIsReplacementItem(
        product?.sku?.[index]
      )
    }

    /* skipped bundle product - need to fix from backend */
    if (product && product.identifier && !isReplacementItem) {
      productCard = (
        <ProductCard
          product={product}
          key={`${product.identifier || ''}`}
          currency={product.currency || '$'}
          isFavorite={true}
          productType={productType}
        />
      )
    }
    return productCard
  }
  renderEmptyFavoritesPage = () => {
    return (
      <div>
        {i18nTranslate(
          'favorites.emptyPage',
          'You do not have any favorite items yet'
        )}
      </div>
    )
  }
  handlePaginationClick = async activePage => {
    favoritesContainer.activePage = activePage
    await favoritesContainer.getFavoriteProductsForFavoritesPage(activePage)
    if (typeof window === 'object') {
      window.scrollTo(0, 0)
    }
  }
  render() {
    const {
      favoritesPageProducts,
      pageSizeForFavoritesPage,
      favoritesCount,
      activePage,
      favoritesPageResponse,
      isFavoriteCallOver,
    } = favoritesContainer

    const favoritesTitle = i18nTranslate(
      'favoritesPage.title',
      'Favorites | Nu Skin'
    )
    return (
      <>
        <MetaDecorator
          title={favoritesTitle}
          imageUrl=""
          imageAlt=""
          description="Favorites page"
          location={this.props}
        />
        {enableQuickView && !isMerchPLP && <QuickView />}
        <Container className="favorites-wrapper px-0">
          <Row noGutters className="py-3">
            <Col
              className="d-flex align-items-center favorites-page-title"
              data-testid="qa-favorites-title">
              {/* <FavoriteIcon
                className="favorite-icon bg-transparent"
                aria-label={i18nTranslate('icons.favorite', 'favorite icon')}
              /> */}
              <h1 className="heading-2">
                <span className="pb-1">
                  {i18nTranslate('favorites.title', 'Favorites')}
                </span>
              </h1>
            </Col>
            {/* should be added when share functionality implemented */}
            {/* <Col
            xs={{ span: 3, offset: 5 }}
            md={{ span: 3, offset: 5 }}
            lg={{ span: 3, offset: 5 }}>
            <Button
              variant="primary w-100 py-2"
              data-testid="qa-favorites-share"
              disabled>
              <Trans i18nKey="favorites.share">SHARE</Trans>
            </Button>
          </Col> */}
          </Row>
          {isEmpty(favoritesPageResponse) ? (
            ''
          ) : favoritesPageProducts && favoritesPageProducts.length > 0 ? (
            <div
              className="favorite-product-wrapper mb-3"
              data-testid="qa-favorite-container">
              {favoritesPageProducts.map(this.renderProducts)}
            </div>
          ) : (
            isFavoriteCallOver && this.renderEmptyFavoritesPage()
          )}

          {favoritesCount > pageSizeForFavoritesPage && (
            <Pagination
              handlePagination={this.handlePaginationClick}
              totalPages={Math.ceil(favoritesCount / pageSizeForFavoritesPage)}
              active={activePage}
            />
          )}
        </Container>
      </>
    )
  }
}

export { Favorites }

// export default Favorites
export default Favorites
